/**
 * **La jauge de remplissage d'un tableau — `CDC-2` F-21.**
 *
 * **ELLE NE NOMME PAS LA STRUCTURE DONT VIENT SON PLAFOND**, repli de la zone floue 9, et
 * ce composant ne prend aucun nom de structure : il n'y a nulle part où en passer un.
 * « Sur un cours mixte, le plafond est celui de la structure du tuteur, et **un élève
 * d'une autre structure lirait sinon un réglage qui n'est pas le sien**. »
 *
 * **AUCUN SEUIL D'AVERTISSEMENT INTERMÉDIAIRE** : « il perdrait son objet ». La jauge ne
 * change donc pas de couleur à 80 % — elle monte, et au plafond le produit refuse et le
 * dit. Un avertissement à mi-chemin ferait deux annonces pour un seul fait.
 *
 * **LE POURCENTAGE EN PERMANENCE, LE VOLUME AU MOMENT DU REFUS**, repli de la zone
 * floue 10 : « un pourcentage ne dit pas si un document de trois mégaoctets entre ; **un
 * volume ne se lit pas d'un coup d'œil pendant qu'on trace** ». Ce composant ne montre
 * donc **que** le pourcentage ; le volume vit dans le refus.
 *
 * **Aucune transition, aucune animation** : elle vit sur la surface de tracé, et « la
 * latence du trait est le critère numéro un ».
 */
type Props = {
  /** Déjà calculé par `pourcentageDeRemplissage`, de `shared/lib`. */
  readonly pourcentage: number;
  /** Vrai au plafond : « le cours est gelé en écriture, pas même le tuteur ne trace ». */
  readonly gele: boolean;
};

export function Jauge({ pourcentage, gele }: Props) {
  return (
    <div className="flex items-center gap-2">
      <div
        role="progressbar"
        aria-valuenow={pourcentage}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Remplissage du tableau"
        className="h-1 w-20 overflow-hidden rounded-plein bg-fond-bloc"
      >
        <div
          // **La teinte ne change pas avec le niveau** : le violet est la langue de
          // l'interface, et la jauge en est. Au plafond elle passe au rouge du statut,
          // parce qu'un fait a eu lieu — pas parce qu'un seuil est franchi.
          className={[
            'h-full',
            gele ? 'bg-statut-echec' : 'bg-action',
          ].join(' ')}
          style={{ width: `${pourcentage}%` }}
        />
      </div>
      <span className="text-13 font-weight-700 tabular-nums text-texte-faible">
        {pourcentage} %
      </span>
    </div>
  );
}
